import React, { Component } from 'react'
import { Form, Icon, Input } from 'antd'
import Label from '../form/Label'
import autofill from '../../utils/AutoFillWrapper'
const FormItem = Form.Item

@autofill
class LoginFields extends Component {
  render() {
    const { getFieldDecorator } = this.props.form
    return (
      <Form layout="vertical" hideRequiredMark={true}>
        <FormItem label={Label('Email address')} hasFeedback>
          {getFieldDecorator('email', {
            rules: [{ required: true, message: 'Please input your email!' }]
          })(
            <Input
              id="loginEmail"
              className="login-email"
              prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
              placeholder="johndoe@automech.io"
            />
          )}
        </FormItem>
        <FormItem label={Label('Password')} hasFeedback>
          {getFieldDecorator('password', {
            rules: [{ required: true, message: 'Please input your Password!' }]
          })(
            <Input
              id="loginPassword"
              className="login-password"
              prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
              type="password"
              placeholder="Password"
            />
          )}
        </FormItem>
      </Form>
    )
  }
}

export default LoginFields



// WEBPACK FOOTER //
// ./src/components/login/LoginFields.js